// extracted by mini-css-extract-plugin
export const root = "featured-blocks-module--root--1gPDc";
export const item = "featured-blocks-module--item--3fvzB";
export const textWrap = "featured-blocks-module--textWrap--1nDwj";
export const grid = "featured-blocks-module--grid--2v9xG";
export const right = "featured-blocks-module--right--q9MZG";
export const image = "featured-blocks-module--image--2HgAt";
export const imageWrap = "featured-blocks-module--imageWrap--4-lYj";
export const featuredImage = "featured-blocks-module--featuredImage--2LDaK";
export const text = "featured-blocks-module--text--1lntd";